module.exports = __webpack_public_path__ + "src/images/git-logo.5861abf4e97e814076c629464632857b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/git-logo.png
// module id = 100
// module chunks = 0